import { canPrint } from '@/features/orders/hooks/usePrintOrder'

/** Set once the tablet setup checklist has been shown on this device. */
export const DEVICE_SETUP_SEEN_KEY = 'deviceSetup:seen'

/** First start of the tablet app on this device: the setup checklist comes before login and contract. */
export function deviceSetupPending(): boolean {
  if (!canPrint) return false
  try {
    return localStorage.getItem(DEVICE_SETUP_SEEN_KEY) !== 'true'
  } catch {
    return false
  }
}
